module.exports = __webpack_public_path__ + "static/media/powered-by-logo.ff44d4fa.svg";